function randomFromInterval(min, max) {
  return Math.random() * (max - min) + min;
}

export function generateDogNose(snoutBottomY, snoutLength, headScale = 1) {
  // Nose size varies continuously based on snout length and random factors
  // Longer snouts can have different nose proportions
  let lengthFactor = snoutLength / 50; // Normalized around 1.0

  // All continuous random parameters (scaled by headScale)
  let noseWidth = randomFromInterval(15, 30) * randomFromInterval(0.85, 1.15) * headScale;
  let noseHeight = randomFromInterval(10, 18) * randomFromInterval(0.9, 1.1) * lengthFactor * headScale;

  // Position nose at the bottom of snout
  let noseY = snoutBottomY - noseHeight / 2;

  // Cartoon dog nose shape (rounded triangle/heart shape)
  let nosePoints = [
    [-noseWidth / 2, noseY - noseHeight / 3],
    [-noseWidth / 2.5, noseY - noseHeight * 0.7],
    [-noseWidth / 4, noseY - noseHeight],
    [0, noseY - noseHeight * 1.05],
    [noseWidth / 4, noseY - noseHeight],
    [noseWidth / 2.5, noseY - noseHeight * 0.7],
    [noseWidth / 2, noseY - noseHeight / 3],
    [noseWidth / 3, noseY],
    [noseWidth / 5, noseY + noseHeight / 4],
    [0, noseY + noseHeight / 3],
    [-noseWidth / 5, noseY + noseHeight / 4],
    [-noseWidth / 3, noseY],
    [-noseWidth / 2, noseY - noseHeight / 3]
  ];

  // Nostrils
  let leftNostril = {
    x: -noseWidth / 5,
    y: noseY - noseHeight / 6
  };

  let rightNostril = {
    x: noseWidth / 5,
    y: noseY - noseHeight / 6
  };

  // Calculate actual nose bottom Y position (lowest point of nose)
  let noseBottomY = noseY + noseHeight / 3;

  return {
    outline: nosePoints,
    leftNostril: leftNostril,
    rightNostril: rightNostril,
    noseBottomY: noseBottomY  // Return actual nose bottom position
  };
}
